import { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';
import _isEmpty from 'lodash/isEmpty';
import globals from '../../utils/globals';
import useSideRail from '../profile/use-side-rail';
import { SideRailContext } from '../../contexts';
import { useApiClient } from '../../hooks/api';
import { connect } from 'react-redux';
import { getWindowDimensions } from '../../utils/sharedHelpers';
import { PAGES } from '../../shared/screener-constants';
import {
  accessTiaaElements,
  calculateOffsets
} from '../../utils/pageOffsetHelpers/pageOffsetHelpers';

const initialState = {};
const ScreenerAppContext = createContext(initialState);
const { Provider: BaseProvider } = ScreenerAppContext;
const { Provider: SideRailProvider } = SideRailContext;

export const AppProvider = ({
  Plans,
  UrlDomain,
  UrlPrefix,
  channel,
  children,
  defaultView,
  distributionPlan,
  mockResponse,
  page,
  prodTestVariable,
  queryStringPlan,
  searchedPlanNumber,
  yyy,
  bluetagcharacteristic
}) => {
  const apiClient = useApiClient({
    baseUrl: globals.apiUrl,
    baseAuthUrl: globals.authApiUrl,
    yyy
  });
  const sideRail = useSideRail();
  const [isMobile, setIsMobile] = useState(getWindowDimensions().width < 768);
  const [pageOffsetsTop, setpageOffsetsTop] = useState(0);

  const handleWindowResize = () => {
    setIsMobile(getWindowDimensions().width < 768);
  };

  useEffect(() => {
    const resize = _debounce(handleWindowResize, 150);
    window.addEventListener('resize', resize);

    return function cleanupListener() {
      window.removeEventListener('resize', resize);
    };
  }, [isMobile]);

  // Handles setting Page Offsets when hosted via a TIAA integrated environment.
  // Basically, TIAA's own header sizes change depending on the site (MyTIAA, Microsites etc.).
  // Microsites have a header that collapses on scroll, hence the listeners.
  useEffect(() => {
    const MAX_ITERATIONS = 20;
    let updateAttempts = 0;
    let tiaaElements = {};

    (function initOffsets() {
      setTimeout(() => {
        tiaaElements = accessTiaaElements();

        if (
          updateAttempts <= MAX_ITERATIONS &&
          _isEmpty(tiaaElements.micrositesNav) &&
          _isEmpty(tiaaElements.mobileNav) &&
          _isEmpty(tiaaElements.tiaaFooter) &&
          _isEmpty(tiaaElements.tiaaHeader)
        ) {
          updateAttempts++;
          initOffsets();
          return;
        }

        setpageOffsetsTop(calculateOffsets(tiaaElements));
      }, 50);
    })();

    const handleScroll = _debounce(() => {
      setpageOffsetsTop(calculateOffsets(tiaaElements));
    }, 10);
    const handleResize = _debounce(() => {
      setpageOffsetsTop(calculateOffsets(tiaaElements));
    }, 10);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return function cleanupListener() {
      window.removeEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageOffsetsTop]);

  const state = {
    yyy,
    mockResponse,
    apiClient,
    channel,
    pageOffsetsTop,
    sideRail,
    Plans,
    distributionPlan,
    searchedPlanNumber,
    queryStringPlan,
    defaultView,
    prodTestVariable,
    isMobile,
    page,
    UrlDomain,
    UrlPrefix,
    bluetagcharacteristic
  };
  return (
    <BaseProvider value={state}>
      <SideRailProvider value={sideRail}>{children}</SideRailProvider>
    </BaseProvider>
  );
};

AppProvider.propTypes = {
  channel: PropTypes.string,
  children: PropTypes.node,
  distributionPlan: PropTypes.string,
  yyy: PropTypes.string,
  mockResponse: PropTypes.bool,
  searchedPlanNumber: PropTypes.string,
  Plans: PropTypes.array,
  page: PropTypes.string,
  queryStringPlan: PropTypes.string,
  defaultView: PropTypes.string,
  prodTestVariable: PropTypes.bool,
  UrlDomain: PropTypes.string,
  UrlPrefix: PropTypes.string,
  bluetagcharacteristic: PropTypes.string
};

AppProvider.defaultProps = {
  page: PAGES.SCREENER
};

const mapStateToProps = state => {
  return {
    searchedPlanNumber: state.filterReducer.inputs.searchedPlanNumber
  };
};

export const Provider = connect(mapStateToProps)(AppProvider);

export default ScreenerAppContext;
